import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const ContactQueryModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <AnimatePresence>
      {/* Background Overlay */}
      <motion.div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {/* Modal Box */}
        <motion.div
          className="bg-white rounded-2xl shadow-xl p-6 w-[90%] max-w-md relative"
          initial={{ scale: 0.8, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.8, opacity: 0, y: 20 }}
          transition={{ duration: 0.25 }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-100"
          >
            <X size={22} />
          </button>

          {/* Content */}
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            Need Help?
          </h2>

          <p className="text-gray-600 mb-3">
            If you have any queries related to{" "}
            <span className="font-semibold">flight</span>
            or <span className="font-semibold">baggage</span>, feel free to
            contact us:
          </p>

          <div className="bg-blue-50 p-4 rounded-xl mb-4 border border-blue-200">
            <p className="text-gray-800 font-medium">📞 Phone / WhatsApp</p>
            <a
              href="tel:+917879110142"
              className="text-blue-600 font-bold block mt-1"
            >
              7879110142
            </a>

            <a
              href="https://wa.me/917879110142"
              target="_blank"
              className="text-green-600 font-semibold underline mt-2 inline-block"
            >
              Chat on WhatsApp
            </a>
          </div>

          <p className="text-sm text-gray-500">
            Our support team will assist you as soon as possible.
          </p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ContactQueryModal;
